const translations = {
    altitudeLabel: 'Altitude (ft)',
    autoOptimizeLabel: 'Auto-optimize Angle',
    autoOptimizeOff: 'Off',
    autoOptimizeOn: 'On',
    pathAngleLabel: 'Path Angle',
    routeSpacingLabel: 'Route Spacing (ft)',
    turnTypeLabel: 'Turn Type',
    turnTypeRacetrack: 'Racetrack',
    turnTypeStraight: 'Straight',
    turnTypeUTurn: 'U-Turn'
};

export default translations;
